import { observer } from 'mobx-react-lite';
import { useImperativeHandle, useRef } from 'react';
import YoutubePlayer, { type YoutubePlayerRef } from '../../views/common/YoutubePlayer';
import { useLessonStore } from './provider/LessonProvider';

export interface LessonPlayerRef {
    /**
     * 특정 시간으로 이동 후 재생
     */
    seekToAndPlay: (time: number) => void;
    /**
     * 재생
     */
    play: () => void;
    /**
     * 일시정지
     */
    pause: () => void;
    /**
     * 상대 시간만큼 이동 (초 단위)
     */
    seekBy: (seconds: number) => void;
}

const LessonPlayer = observer(({ ref }: { ref: React.RefObject<LessonPlayerRef | null> }) => {
    const lessonStore = useLessonStore();

    const videoId = lessonStore.lesson?.videoId || '';
    const youtubePlayerRef = useRef<YoutubePlayerRef>(null);

    useImperativeHandle(ref, () => ({
        seekToAndPlay: (time: number) => {
            youtubePlayerRef.current?.clearRepeatRange();
            youtubePlayerRef.current?.seekToAndPlay(time);
        },
        play: () => {
            youtubePlayerRef.current?.play();
        },
        pause: () => {
            youtubePlayerRef.current?.pause();
        },
        seekBy: (seconds: number) => {
            const currentTime = youtubePlayerRef.current?.getCurrentTime() ?? 0;
            const newTime = Math.max(0, currentTime + seconds);
            youtubePlayerRef.current?.seekTo(newTime);
        },
    }));

    return (
        <div className="border-base-300 aspect-video overflow-hidden rounded-md border">
            {lessonStore.isLoading || !videoId ? (
                <div className="skeleton h-full w-full rounded-none"></div>
            ) : (
                <YoutubePlayer
                    ref={youtubePlayerRef}
                    videoId={videoId}
                    onTimeUpdate={(currentTime) => {
                        lessonStore.handleTimeUpdate(currentTime);
                    }}
                />
            )}
        </div>
    );
});

export default LessonPlayer;
